
const COAST_RULES = {
        0: {
            any_concern: [{eq: true}],

            respirations: [{lt: 30}, {gt: 60}],

            respiratory_distress: [{eq: 'moderate'}, {eq: 'severe'}],

            o2_flow: [{gt: 0}],

            pulse: [{gt: 160}, {lt: 90}],

            avpu: [{eq: 'v'}, {eq: 'p'}, {eq: 'u'}]
        },
        1: {
            any_concern: [{eq: true}],

            respirations: [{lt: 20}, {gt: 40}],

            respiratory_distress: [{eq: 'moderate'}, {eq: 'severe'}],

            o2_flow: [{gt: 0}],

            pulse: [{gt: 140}, {lt: 90}],

            avpu: [{eq: 'v'}, {eq: 'p'}, {eq: 'u'}]
        },
        2: {
            any_concern: [{eq: true}],

            respirations: [{lt: 20}, {gt: 30}],

            respiratory_distress: [{eq: 'moderate'}, {eq: 'severe'}],

            o2_flow: [{gt: 0}],

            pulse: [{gt: 120}, {lt: 70}],

            avpu: [{eq: 'v'}, {eq: 'p'}, {eq: 'u'}]
        },
        3: {
            any_concern: [{eq: true}],

            respirations: [{lt: 10}, {gt: 20}],

            respiratory_distress: [{eq: 'moderate'}, {eq: 'severe'}],

            o2_flow: [{gt: 0}],

            pulse: [{gt: 100}, {lt: 60}],

            avpu: [{eq: 'v'}, {eq: 'p'}, {eq: 'u'}]
        },
        4: {
            respirations: [{lte3: 8}, {lt: 12},
                           {gt3: 24}, {gt2: 20}],
            o2_stats: [{lte3: 91}, {lt2: 94}, {lt: 96}],
            o2_flow: [{gt2: 0}],
            temperature: [{lte3: 35}, {lt: 36.1}, {gte2: 39.1}, {gt: 38}],
            blood_pressure: [{lte3: 90}, {lt2: 101}, {lt: 111},
                             {gte3: 220}],
            pulse: [{gte3: 131}, {gte2: 111}, {gte: 91},
                    {lte3: 40},  {lt: 51}],
            avpu: [{eq3: 'v'}, {eq3: 'p'}, {eq3: 'u'}]
        }
    }


const CoastAgeRange = {
      0: '0 - 1',
      1: '1 - 5',
      2: '5 - 12',
      3: '12+'
    }


let CoastGroup = function(age) {
    if (age < 1) {
        return 0;
    } else if (age < 5) {
        return 1;
    } else if (age < 12) {
        return 2;
    } else  {
        return 3;
    }
  }


exports.rules = COAST_RULES
exports.ageRange = CoastAgeRange
exports.group = CoastGroup
